// Styles for GiftCardsList go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledGiftCardsList = styled.div`
  .gift-card-wrapper {
    border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
  }

  .gift-card-image {
    width: ${toRem(96)};
    height: ${toRem(58)};
    border-radius: ${toRem(4)};
  }

  .gift-card-profile-image {
    width: ${toRem(48)};
    height: ${toRem(28)};
  }

  .gift-card-details {
    width: 100%;
  }

  .gift-card-number,
  .gift-card-expiry {
    color: ${baseVariables.color.neutral40};
  }

  .gift-card-amount {
    @media ${baseVariables.mediaQuery.md} {
      font-size: ${toRem(22)};
    }
  }

  .gift-card-number {
    @media ${baseVariables.mediaQuery.md} {
      font-size: ${toRem(16)};
    }
  }

  .giftCardRow {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    @media ${baseVariables.mediaQuery.md} {
      grid-template-columns: repeat(2, 1fr);
      gap: ${toRem(24)};
    }
  }

  .cardpin {
    gap: ${toRem(8)};
    margin-bottom: ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      margin-bottom: 0;
    }
  }

  .min-width-max-content {
    min-width: max-content;
  }

  // Badge overlay variants for gift card status (BAU - unchanged)
  .m-badge-overlay-neutral {
    background: rgba(28, 28, 28, 0.2);
    color: ${baseVariables.color['base10']};
    border-radius: 4px;
  }

  // Wallet-specific badge styling - uses Badge overlay with custom styling
  &.wallet-widget-variant {
    .wallet-badge-neutral,
    .wallet-badge-merch {
      display: flex;
      height: ${toRem(22)};
      padding: 0 ${toRem(8)} !important;
      justify-content: center;
      align-items: center;
      font-size: ${toRem(12)};
      line-height: 1.33;
      border-radius: var(--border-radius-xs, ${toRem(4)});
      width: fit-content;

      // Icon styling - inherited from m-badge-overlay
      [class*='icon-'] {
        font-size: ${toRem(16)};
        margin-right: ${toRem(4)};
      }
    }

    // Neutral badges (Locked, On Hold) - gray background with black text
    .wallet-badge-neutral {
      background: var(--t-brand-bg-color);
      color: ${baseVariables.color['base10']};
    }

    // New Card badge - orange background with black text
    .wallet-badge-merch {
      background: var(--t-accent-color);
      color: ${baseVariables.color['base10']};
    }
  }

  .card-expiring-icon {
    color: ${baseVariables.color['alert40']};
    &:before {
      font-size: ${toRem(16)};
    }
  }

  .card-expired-icon {
    color: ${baseVariables.color['alert50']};
    &:before {
      font-size: ${toRem(16)};
    }
  }

  .card-expiring-label {
    color: ${baseVariables.color['alert40']};
  }
  .card-expired-label {
    color: ${baseVariables.color['alert50']};
  }

  .gift-card-number-row {
    gap: ${toRem(12)};
  }

  .gift-card-amount-row {
    gap: var(--General-spacer-03, ${toRem(16)});
  }

  .gift-card-status-badges {
    display: flex;
    flex-wrap: wrap;
    gap: ${toRem(8)};
  }

  .gift-card-expiry-row {
    gap: ${toRem(8)};
  }

  .gift-card-trailing {
    gap: ${toRem(16)};
    flex-shrink: 0;
  }

  .gift-card-view-cta {
    flex-shrink: 0;
    margin: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: ${toRem(3)};
    font-size: ${toRem(14)};
    font-weight: 500;
    line-height: 1.5;
    color: ${baseVariables.color['base10']};

    &:hover {
      text-decoration: underline;
    }
  }
`;
